import { render, staticRenderFns } from "./le-petit-mouton.vue?vue&type=template&id=641ff1ee&scoped=true"
import script from "./le-petit-mouton.vue?vue&type=script&lang=js"
export * from "./le-petit-mouton.vue?vue&type=script&lang=js"
import style0 from "./le-petit-mouton.vue?vue&type=style&index=0&id=641ff1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ff1ee",
  null
  
)

export default component.exports